import { Box, Divider, FillPreview, Text } from "@wix/design-system";
import { MoreSmall } from "@wix/wix-ui-icons-common";
import React from "react";
import { SWATCH_TOGGLE } from "./../../color-picker/button-color-swatches/data-hooks";
import { SingleColorSwatch } from "../new-color-picker/components/single-color-swatch";
import classes from "./button-color-swatches-scss";
const SWATCH_COLORS = ["#000624", "#25A55A", "#FFB700", "#E62214", "#116DFF"];
const ButtonColorSwatches = ({
  label,
  color,
  onChange,
  dataHook,
  defaultColor,
  onMorePress,
  moreButtonRef
}) => {
  return /* @__PURE__ */ React.createElement(Box, { gap: "SP3", direction: "vertical", dataHook }, /* @__PURE__ */ React.createElement(Text, { size: "small" }, label), /* @__PURE__ */ React.createElement(Box, { display: "flex", width: "100%", alignContent: "stretch", gap: "SP3" }, SWATCH_COLORS.map((c) => /* @__PURE__ */ React.createElement(
    SingleColorSwatch,
    {
      key: c,
      fill: c,
      selectedColor: color || defaultColor,
      onClick: onChange,
      className: classes.fillPreview
    }
  )), /* @__PURE__ */ React.createElement(Divider, { direction: "vertical", className: classes.divider }), /* @__PURE__ */ React.createElement(
    FillPreview,
    {
      fill: /* @__PURE__ */ React.createElement(MoreSmall, null),
      className: classes.fillPreview,
      onClick: onMorePress,
      ref: moreButtonRef,
      dataHook: SWATCH_TOGGLE
    }
  )));
};
export {
  ButtonColorSwatches
};
//# sourceMappingURL=button-color-swatches.js.map
